import { retrievePermissions } from "utils/cryptoStorage";

export const hasRequiredPermission = (requiredPermissions, currentPath) => {
  const pathMapping = {
    "/user-management": 2,
    "/user-management/manage-roles": 1,
    "/notification": 3,
    "/news-management": 4,
    "/my-news-article": 4,
    "/approval-management": 4,
  };

  const permission = requiredPermissions.find((p) => {
    // Find key in pathMapping corresponding to the current permission module_id
    const relevantPath = Object.keys(pathMapping).find((key) => {
      const match = pathMapping[key] === p.module_id;
      return match;
    });

    // Check if the current path includes the relevant path and if view permission is true
    const hasPermission = currentPath?.includes(relevantPath) && p.view;

    return hasPermission;
  });

  return !!permission; // Return true if a permission was found, otherwise false
};

const permissions = retrievePermissions();

export const isPermit = (moduleId, permissionName) => {
  // Find the permission object that matches the given module_id
  const permissionObject = permissions?.find(
    (permission) => permission?.module_id === moduleId
  );
  // Check if the permission specified by permissionName is true
  const hasPermission = permissionObject && permissionObject[permissionName];

  return !!hasPermission;
  // Return true if the permission is granted, otherwise false
};
